import * as APIModels from "../../models";

function flatten(template: APIModels.MatterTemplate): FlattenedMatterTemplate {
    return {
        id: template.id,
        uploaderId: template.userID,
        uploader: template.user?.name,
        filename: template.filename,
        notes: template.notes,
    } as FlattenedMatterTemplate;
}
function reduce(matter: APIModels.MatterResponse): MatterReduced {
    const reducedMappings: Array<MatterMappingReduced> =
        matter.mappings?.map((mapping) => {
            return {
                id: mapping.id ?? APIModels.EmptyGuid,
                key: mapping.fieldKey ?? "",
                value: mapping.fieldName ?? "",
            };
        }) ?? [];
    return {
        id: matter.id,
        matterNumber: matter.matterNumberV2,
        mappings: reducedMappings,
        identifier: {
            id: matter.identifier?.matterMapping?.id,
            key: matter.identifier?.matterMapping?.fieldKey,
            value: matter.identifier?.matterMapping?.fieldName,
        },
    } as MatterReduced;
}

type FlattenedMatterTemplate = {
    id: string;
    uploaderId: string; // Uploaders ID
    uploader: string; // User's First and Last Name
    filename: string; // Filename of pdf not path
    notes: string; // Notes
};

type MatterMappingReduced = {
    id: string;
    key: string;
    value: string;
};

type MatterReduced = {
    id: string | undefined;
    identifier: MatterMappingReduced;
    matterNumber: string | undefined;
    mappings: Array<MatterMappingReduced>;
};

type WriteableMergeField = {
    key: number;
    identifier: string;
    value: string;
};

type WriteableMergeFields = Array<WriteableMergeField>;

export {
    /**
     * Used to make a reduced object with only need fields when looping in the
     * Material table for example
     * @example
     * const mattersReduced = matters.map(reduce)
     *
     * @param {APIModels.MatterResponse} matter - Matter from the Server to be mapped
     * @returns {MatterReduced} the returned reduced matter
     */
    reduce,
    /**
     * Used to make a flattened Template that has the same structure of the @see {APIModels.IFileInfo}
     * but with specific uses in matterManagement
     * @example
     * const mattersTemplatesFlattened = mattersTemplates.map(flatten)
     *
     * @param {APIModels.MatterTemplate} matter - MatterTemplate from the Server to be mapped
     * @returns {FlattenedMatterTemplate} the returned flattened and expanded with data from
     * the server
     */
    flatten,
    type FlattenedMatterTemplate,
    type MatterMappingReduced,
    type MatterReduced,
    type WriteableMergeField,
    type WriteableMergeFields,
};
